import { useState } from 'react'
import { InputHighlightedValue } from './input-highlighted-value'
import * as css from './styles'
import { t } from '@lingui/core/macro'

export const CustomHighlightInput = ({ delimiter, position }) => {
  const [text, setText] = useState('')

  const handleTextChange = event => {
    const { value } = event.target
    setText(value)
  }

  return (
    <css.Container>
      <css.HighlightInput
        multiline
        value={text}
        onChange={handleTextChange}
        placeholder={t`Example text`}
        inputProps={{ maxLength: 225 }}
      />
      <css.HighlightOverlay>
        <InputHighlightedValue delimiter={delimiter} position={position} previewValue={text} />
      </css.HighlightOverlay>
    </css.Container>
  )
}
